import "./SideMenu.css";
import "../../../../components/Navbar.css";
import DashboardMenuContent from "./DashboardMenuContent";

const SideMenu = () => {
  return (
    <>
      <div className="menu-box">
        <DashboardMenuContent />
      </div>
    </>
  );
};

export default SideMenu;
